// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "v1.3.12-b75ac1514253885529235e5271347f2134d49b60/scripts/" + chunkId + ".js";
};